import jsPDF from 'jspdf';
import { GenerateOattInvoicePDFParams } from './types';
import { derivedMonthLabel, generateOattFilename } from './formatters';
import {
  renderOattHeader,
  renderRevisionNotice,
  renderExportsHeading,
  renderScheduleSection,
  renderTotalsBlock,
  renderFooterNotice,
} from './oattInvoiceComponents';

/**
 * Assemble a complete OATT invoice jsPDF document.
 * Each visual section is delegated to a focused helper in oattInvoiceComponents.ts.
 */
export const buildOattInvoiceDocument = async (
  { invoice, monthLabel, primaryIssuer, accountNumber }: GenerateOattInvoicePDFParams,
): Promise<jsPDF> => {
  const doc = new jsPDF({ unit: 'mm', format: 'a4' });
  const displayMonthLabel = derivedMonthLabel(invoice.billing_period, monthLabel);
  const acctNo = accountNumber ?? String(invoice.customer_id);

  let y = 8;
  y = await renderOattHeader(doc, y, invoice, primaryIssuer);
  y = renderRevisionNotice(doc, invoice, y);
  y = renderExportsHeading(doc, invoice, y, acctNo, displayMonthLabel, primaryIssuer);
  y = renderScheduleSection(doc, invoice, y);
  y = renderTotalsBlock(doc, invoice, y);
  renderFooterNotice(doc, y, invoice.vendor_comment);

  return doc;
};

/**
 * Generate and download an OATT invoice PDF.
 */
export const generateOattInvoicePDF = async (
  params: GenerateOattInvoicePDFParams,
): Promise<void> => {
  const doc = await buildOattInvoiceDocument(params);
  const { invoice, monthLabel } = params;

  const filename = generateOattFilename(
    invoice.customer_code,
    invoice.billing_period,
    monthLabel,
    invoice.is_revision,
    invoice.revision_no,
  );

  doc.save(filename);
};
